import {
	AbandonFlowModal,
	MainFooter,
	MainHeader,
	StepProgressBar,
	StyledGrid,
	SwipeableEdgeDrawer,
} from 'presentation/components';
import React, {Fragment} from 'react';
import {useTelehealthBooking} from './hooks/useTelehealthBooking';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Box, Stack} from '@mui/material';
import {CustomStepper} from 'presentation/components/CustomStepper';
import {OurDoctorSpecialtyAlert} from 'presentation/components/OurDoctor/SpecialtyAlert';
import {TelehealthSearchBar} from '../../components/TelehealthSearchBar';
import {ChangeDialogsGroup} from 'presentation/modules/booking/shared/ui/components/ChangeDialogsGroup';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {translations} from 'presentation/translations-new';
import {StyledBox} from './styles';
import {TelehealthStepsWrapper} from './steps/TelehealthStepsWrapper';
import {TelehealthSummarySectionGroup} from '../../components/TelehealthSummarySectionGroup';
import {QualityCertificationBanner} from '../../components/QualityCertificationBanner';

const {abandonFlow, appointmentSummary} = translations['pt-br'].privateFlow.bookingFlow;

export function TelehealthBooking() {
	const {
		headerTitle,
		handleBack,
		handleClose,
		shouldHideBackBtn,
		isMobile,
		hideStepBar,
		activeBookingFlowStep,
		stepLabels,
		shouldHideSearchBar,
		shouldShowOurDoctorAlert,
		searchBarTagId,
		searchBarPlaceHolder,
		setActiveBookingFlowStep,
		handleConfirmExitFlow,
		abandonFlowState,
		setAbandonFlowState,
		isLastStep,
		showSwipeableDrawerBookingSummary,
		openDrawerState,
		setOpenDrawerState,
		handleChangeModals,
		handleNext,
		isDesktop,
		shouldUseNewResumeLayout,
	} = useTelehealthBooking();

	return (
		<Fragment>
			<MainHeader
				title={headerTitle}
				dataTagId={{
					backButton: AppointmentBookingEnum.CLICK_VOLTAR_AGENDAMENTO,
					closeButton: AppointmentBookingEnum.CLICK_DESCARTAR_AGENDAMENTO,
				}}
				handleBack={handleBack}
				handleClose={handleClose}
				hideBackBtn={shouldHideBackBtn}
				variant="subRoute">
				{hideStepBar ? null : (
					<StyledGrid.Root px={isMobile ? 2 : 4} pb={3}>
						<StyledGrid.Item sm={12} md={12} lg={12}>
							<Stack gap={3}>
								{isMobile ? (
									<StepProgressBar
										mt={1}
										currentStep={activeBookingFlowStep + 1}
										totalSteps={stepLabels.length}
									/>
								) : (
									<CustomStepper
										dataTagId={AppointmentBookingEnum.NOME_STEP}
										activeStep={activeBookingFlowStep}
										stepLabels={stepLabels}
									/>
								)}
							</Stack>
						</StyledGrid.Item>
					</StyledGrid.Root>
				)}

				{shouldHideSearchBar ? null : (
					<Fragment>
						<TelehealthSearchBar
							activeStep={activeBookingFlowStep}
							placeholder={searchBarPlaceHolder}
							searchDataTagId={searchBarTagId}
						/>
						{shouldShowOurDoctorAlert ? <OurDoctorSpecialtyAlert /> : null}
					</Fragment>
				)}
			</MainHeader>

			<Fragment>
				<StyledGrid.Root p={isMobile ? 2 : 4} height="100%">
					<StyledGrid.Item sm={12} md={12} lg={shouldUseNewResumeLayout ? 12 : 8}>
						<TelehealthStepsWrapper
							activeStep={activeBookingFlowStep}
							handleBack={handleBack}
							handleNext={handleNext}
							stepLabels={stepLabels}
						/>
					</StyledGrid.Item>
					{isDesktop && !shouldUseNewResumeLayout ? (
						<StyledGrid.Item md={4} lg={4}>
							<TelehealthSummarySectionGroup
								activeStep={activeBookingFlowStep}
								handleChangeModals={handleChangeModals}
								stepLabels={stepLabels}
							/>
						</StyledGrid.Item>
					) : null}
				</StyledGrid.Root>

				<StyledBox $isLastStep={isLastStep}>
					<QualityCertificationBanner />
					<MainFooter />
				</StyledBox>

				{showSwipeableDrawerBookingSummary ? (
					<SwipeableEdgeDrawer
						type="with-appbar"
						title={appointmentSummary}
						open={openDrawerState}
						setOpen={setOpenDrawerState}
						customDrawerHeight={openDrawerState ? 'auto' : undefined}>
						<Box paddingInline={2} paddingBottom={2} height={'100%'} overflow={'auto'}>
							<TelehealthSummarySectionGroup
								activeStep={activeBookingFlowStep}
								handleChangeModals={handleChangeModals}
								stepLabels={stepLabels}
								showTitle={false}
								disableGutters={true}
							/>
						</Box>
					</SwipeableEdgeDrawer>
				) : null}
			</Fragment>

			<ChangeDialogsGroup
				flowType={FlowEnum.TELEHEALTH}
				setActiveBookingFlowStep={setActiveBookingFlowStep}
			/>
			<AbandonFlowModal
				open={abandonFlowState}
				setOpen={setAbandonFlowState}
				headerTitle={abandonFlow.headerTitle}
				title={abandonFlow.title}
				description={abandonFlow.description}
				handleConfirm={handleConfirmExitFlow}
				confirmButtondataTagId={AppointmentBookingEnum.ABANDONOU_AGENDAMENTO}
				modaldataTagId={AppointmentBookingEnum.VISUALIZOU_MODAL_ABANDONO}
			/>
		</Fragment>
	);
}
